import type { RouteObject } from "react-router-dom-7"

import { globToFlatRoutes, layout } from "~/shared/lib/routing"
import { RouteErrorBoundary } from "~/domain/user-session"

export const routes: RouteObject[] = [
	layout(() => import('./layout'),
		globToFlatRoutes(import.meta.glob(["./routes/*/index.tsx"])).map(route => ({ ErrorBoundary: RouteErrorBoundary, ...route }))
	)
]